import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  root: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(20, 0),
    "& img": {
      marginBottom: "24px",
    },
  },

  smallRoot: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(20, 0),
    "& img": {
      width: "15%",
      height: "15%",
      marginBottom: "15px",
    },
  },
}));
